import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { BookkeepingRoutingModule } from './bookkeeping-routing.module';
import { BookkeepingComponent } from './bookkeeping.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxFileDropModule } from 'ngx-file-drop';
import { ClipboardModule } from 'ngx-clipboard';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ModalModule } from "ngx-bootstrap/modal";
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap/datepicker';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule,  } from '@angular/material/core';
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatMenuModule} from '@angular/material/menu';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import { AddNewInvoicePageComponent } from './add-new-invoice-page/add-new-invoice-page.component';
import { UploadDocumentComponent } from './add-new-invoice-page/upload-document/upload-document.component';
import { TableComponent } from './components/table/table.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FilterSidebarComponent } from './filter-sidebar/filter-sidebar-component';
import { InboxFilterComponent } from './inbox-filter/inbox-filter.component';
import { ImportTransactionsComponent } from './import-transactions/import-transactions.component';
import { DailySyncModalComponent } from './import-transactions/daily-sync/daily-sync-modal.component';
import { ImportHistoryComponent } from './import-history/import-history.component';

import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgSelectModule } from '@ng-select/ng-select';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { PanZoomDirective } from './components/pdf-viewer/pan-zoom.directive';
import { DateTextInputDirective } from './directives/date-text-input.directive';
import { UploadSidebarComponent } from './components/upload-sidebar/upload-sidebar.component';
import { SettingsSidebarComponent } from './components/settings-sidebar/settings-sidebar.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { AccountNumberPipe } from './pipes/account-number.pipe';
import { DocumentPlaceholderComponent } from './add-new-invoice-page/document-placeholder/document-placeholder.component';
import { SharedService } from './services/shared-service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UploadInvoiceFormComponent } from './add-new-invoice-page/upload-invoice-form/upload-invoice-form.component';
import { ActivityComponent } from './add-new-invoice-page/activity/activity.component';
import { InvoicePaymentStatusPipe } from './pipes/invoice-payment-status.pipe';
import { SupplierContanctsComponent } from './add-new-invoice-page/supplier-contancts/supplier-contancts.component';
import { AddLinesComponent } from './add-new-invoice-page/add-lines/add-lines.component';
import { AddLinesOneLineComponent } from './add-new-invoice-page/add-lines-one-line/add-lines-one-line.component';
import { TotalsLineNewComponent } from './add-new-invoice-page/totals-line-new/totals-line-new.component';
import { TotalsLineHeaderNewComponent } from './add-new-invoice-page/totals-line-header-new/totals-line-header-new.component';
import { ShortLogoPipe } from './pipes/short-logo.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { KeyValuePairsComponent } from './add-new-invoice-page/key-value-pairs/key-value-pairs.component';
import { ProcessingErrorComponent } from './components/processing-error/processing-error.component';
import { BookkeepingFilterComponent } from './components/bookkeeping-filter/bookkeeping-filter.component';
import { RelatedComponent } from './add-new-invoice-page/related/related.component';
import { RelatedContactComponent } from './add-new-invoice-page/related-contact/related-contact.component';
import { ContactExpensesComponent } from './add-new-invoice-page/contact-expenses/contact-expenses.component';
import { ContactActivityComponent } from './add-new-invoice-page/contact-activity/contact-activity.component';
import { AddSymbolPipe } from './pipes/add-symbol.pipe';
import { SharedModule } from '../shared/shared.module';
import { NotesComponent } from './add-new-invoice-page/notes/notes.component';
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { BankTransactionDetailComponent } from './add-new-invoice-page/bank-transaction-detail/bank-transaction-detail.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { RelatedTasksComponent } from './components/related-tasks/related-tasks.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { InvoicePreviewComponent } from './add-new-invoice-page/invoice-preview/invoice-preview.component';
import { InvoicePreviewWebComponent } from './add-new-invoice-page/invoice-preview-web/invoice-preview-web.component';
import { CommonSharedModule } from 'src/app/shared/shared.module';
import { EntertainmentDetailsComponent } from './entertainment-details/entertainment-details.component';
import { FormAssignmentDialogComponent } from './components/form-assignment-dialog/form-assignment-dialog.component';
import { TaskDetailsDialogComponent } from './components/task-details-dialog/task-details-dialog.component';
import { InvoiceDisplaySettingsDialogComponent } from './components/invoice-display-settings-dialog/invoice-display-settings-dialog.component';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { CodingSuggestionsComponent } from './components/coding-suggestions/coding-suggestions.component';
import { TasksModule } from '../tasks/tasks.module';
import { RecordPanelOpener } from '../tasks/record-review';
import { RecordPanelHostComponent } from './record-panel/record-panel-host.component';
import { RecordPanelService } from './record-panel/record-panel.service';
import { PortalModule } from '@angular/cdk/portal';

@NgModule({
  declarations: [
    BookkeepingComponent,
    RecordPanelHostComponent,
    SidebarComponent,
    FilterSidebarComponent,
    InboxFilterComponent,
    DailySyncModalComponent,
    ImportTransactionsComponent,
    // SD-1207: the import wizard's History tab.
    ImportHistoryComponent,
    AddNewInvoicePageComponent,
    UploadDocumentComponent,
    TableComponent,
    PdfViewerComponent,
    PanZoomDirective,
    DateTextInputDirective,
    UploadSidebarComponent,
    SettingsSidebarComponent,
    AccountNumberPipe,
    DocumentPlaceholderComponent,
    UploadInvoiceFormComponent,
    ActivityComponent,
    InvoicePaymentStatusPipe,
    SupplierContanctsComponent,
    AddLinesComponent,
    AddLinesOneLineComponent,
    TotalsLineNewComponent,
    TotalsLineHeaderNewComponent,
    ShortLogoPipe,
    KeyValuePairsComponent,
    ProcessingErrorComponent,
    BookkeepingFilterComponent,
    RelatedComponent,
    RelatedContactComponent,
    ContactExpensesComponent,
    ContactActivityComponent,
    AddSymbolPipe,
    NotesComponent,
    BankTransactionDetailComponent,
    RelatedTasksComponent,
    InvoicePreviewComponent,
    InvoicePreviewWebComponent,
    EntertainmentDetailsComponent,
    FormAssignmentDialogComponent,
    TaskDetailsDialogComponent,
    InvoiceDisplaySettingsDialogComponent,
    CustomCurrencyPipe,
    CodingSuggestionsComponent
  ],
  imports: [
    CommonModule,
    TasksModule,
    OverlayModule,
    PortalModule,
    CarouselModule.forRoot(),
    BookkeepingRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule, // Make sure this is included
    NgxFileDropModule,
    PdfViewerModule,
    ModalModule.forRoot(),
    DateRangePickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,  // Make sure this is included
    MatProgressSpinnerModule, 
    DropDownListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ClipboardModule,
    TypeaheadModule.forRoot(),
    NgSelectModule,
    InlineSVGModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    SharedModule,
    CommonSharedModule,
    PickerModule,
    EmojiModule ,
    MatStepperModule,
    MatIconModule
  ],
  exports: [
    UploadDocumentComponent,
    SidebarComponent,
    FilterSidebarComponent,
    ShortLogoPipe,
    UploadInvoiceFormComponent,
    SupplierContanctsComponent,
    AddSymbolPipe,
    ActivityComponent,
    ContactActivityComponent,
    NotesComponent,
    RelatedTasksComponent,
    InvoicePreviewComponent,
    InvoicePreviewWebComponent,
    CustomCurrencyPipe,
    CodingSuggestionsComponent,
    // Exported so the Emails inbox can preview an attachment with the same viewer rather than
    // opening a blob URL in a new browser tab. Declaring it in two modules is not allowed, and
    // the inbox already imports this module.
    PdfViewerComponent,
    PanZoomDirective,
    // Exported so the Transactions ledger can open the same import wizard rather
    // than growing a second one. Its other host, FilterSidebarComponent, is in this
    // module and so never needed the export.
    ImportTransactionsComponent,
    // Exported so the Emails page can open a bill in the same detail panel the inbox
    // uses, in place over the message. "View bill" used to navigate to /inbox, which
    // threw away the email the person was reading to show them one field of it.
    AddNewInvoicePageComponent
  ],
  providers: [
    SharedService,
    // Opens a record's side panel from a Tasks card row (TasksModule's RecordPanelOpener).
    { provide: RecordPanelOpener, useClass: RecordPanelService }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BookkeepingModule { }
